import ButtonBack from '@/components/_common/ButtonBack';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import Authorities from '@/types/Authority';
import { Button, Divider } from 'antd';
import React from 'react';
import GroupCreateModal from '../GroupCreateModal';
import { useDisclosure } from '@/hooks';
import { hasPermissions } from '@/utils/functions/hasPermissions';

interface Props {
  disabled: boolean;
}

const GroupFooter: React.FC<Props> = ({ disabled }) => {
  const [modalCreateGroupOpen, modalCreateGroupActions] = useDisclosure();

  return (
    <>
      <Divider />

      <SpaceForButton>
        <ButtonBack
          path="/app/operational/inventory/groups"
          disabled={disabled}
        />

        <Button
          block
          type="primary"
          onClick={modalCreateGroupActions.open}
          disabled={!hasPermissions([Authorities.REGISTER_GROUP_ADD])}
        >
          Novo grupo
        </Button>
      </SpaceForButton>

      <GroupCreateModal
        onCancel={modalCreateGroupActions.close}
        open={modalCreateGroupOpen}
      />
    </>
  );
};

export default GroupFooter;
